<template>
    <div class="tw-min-h-screen tw-min-w-full">
        <l-loading v-if="!initialized" :show="true" />
        <component :is="layout" v-else>
            <router-view />
        </component>
        <vue-progress-bar />
        <l-modal
            v-show="showOTPModal"
            size="m"
            data-test-id="profile-page-otp-modal"
            :close-on-backdrop-click="false"
        >
            <template #header>
                {{ $t("profile.OTPtitle") }}
            </template>
            <template #body>
                <l-user-profile-edit-o-t-p-password @close="showOTPModal = false" />
            </template>
        </l-modal>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LLoading from "@/components/LLoading";
import LModal from "@/components/LModal";
import LUserProfileEditOTPPassword from "@/components/LUserProfileEdit/LUserProfileEditOTPPassword";

import LayoutDefault from "@/layouts/LayoutDefault";
import LayoutBlank from "@/layouts/LayoutBlank";

import { loadLanguageAsync } from "@/i18n";

const DEFAULT_LAYOUT = "LayoutDefault";
const BLANK_LAYOUT = "LayoutBlank";

export default {
    components: {
        LLoading,
        LayoutDefault,
        LayoutBlank,
        LModal,
        LUserProfileEditOTPPassword,
    },
    data() {
        return {
            showOTPModal: false,
        };
    },
    computed: {
        ...mapGetters({
            locale: "users/current/locale",
            initialized: "auth/initialized",
            currentUser: "users/current/user",
        }),
        layout() {
            // we set a blank layout for the initial load to prevent flickering
            // - auth check not finished
            // - initial route is always an empty "" without name for vue-router
            if (!this.initialized || (!this.$route.hash && !this.$route.name)) return BLANK_LAYOUT;
            return this.$route.meta.layout ?? DEFAULT_LAYOUT;
        },
    },
    watch: {
        locale: {
            immediate: true,
            async handler(newValue) {
                try {
                    const locale = await loadLanguageAsync(newValue);
                    this.$root.$i18n.locale = locale;
                    this.$moment.locale(locale);
                } catch (err) {
                    // Language not available, fetch fallback
                    const locale = await loadLanguageAsync();
                    this.$root.$i18n.locale = locale;
                    this.$moment.locale(locale);
                }
            },
        },
        currentUser: {
            immediate: true,
            handler(currentUser) {
                if (currentUser?.hasOTP) {
                    this.showOTPModal = true;
                }
            },
        },
    },
    async created() {
        // Initialize auth status
        await this.$store.dispatch("auth/init");

        // Store subscription
        this.$store.subscribe((mutation /*, state*/) => {
            if (!mutation.type) return;

            switch (mutation.type) {
                // Progress bar watcher
                case "api/progress/start":
                    this.$Progress.start();
                    break;
                case "api/progress/finish":
                    this.$Progress.finish();
                    break;
            }
        });

        // Event tracking
        await Promise.all([
            this.$store.dispatch("events/getNames"),
            this.$store.dispatch("events/getProperties"),
        ]).catch(() => {});
    },
};
</script>

<style>
/* Bootstrap */
/* @import './../node_modules/bootstrap/dist/css/bootstrap.css'; */
@import "./../node_modules/bootstrap-vue/dist/bootstrap-vue.css";

/* Main */
@import "./styles/main.css";
</style>
